import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';

import { ViewboxGuestHttpClient } from './viewbox-guest-http-client';
import { ViewboxGuestActions } from './viewbox-guest.store';

@Injectable({ providedIn: 'root' })
export class ViewboxGuestEffects {
  public save$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ViewboxGuestActions.save),
      mergeMap(({ payload }) =>
        this.viewboxGuestHttpClient.save(payload).pipe(
          switchMap(guest => [ViewboxGuestActions.saveSuccess({ payload: guest })]),
          catchError(error => of(ViewboxGuestActions.saveFailed({ payload: error }))),
        ),
      ),
    ),
  );
  constructor(
    private actions$: Actions,
    private viewboxGuestHttpClient: ViewboxGuestHttpClient,
  ) {}
}
